export default function getIsSpecialUICondition() {
	const isSpecialUICondition = localStorage.getItem('sv_is_special_condition');
	return isSpecialUICondition === '1';
}
